import React from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import theme from "../../theme";

const CampaignTable = ({ data, columns, actions }) => {
  const hoverBgColor = useColorModeValue("gray.200", "gray.700");
  const buttonBg = useColorModeValue("gray.50", "gray.600");
  const iconColor = useColorModeValue(theme.colors.lightText, theme.colors.darkText);
  const buttonHoverBg = useColorModeValue("gray.100", "gray.600");

  return (
    <Box overflowX="auto">
      {data.length === 0 ? (
        <Box textAlign="center" p={4}>
          No data available
        </Box>
      ) : (
        <Table size="sm" mt={8} mb={4}>
          <Thead>
            <Tr>
              {columns.map((column, index) => (
                <Th key={index} style={{ ...column.style, minWidth: column.style?.width }}>
                  {column.header}
                </Th>
              ))}
              {actions && <Th>Actions</Th>}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row, rowIndex) => (
              <Tr key={row._id} _hover={{ backgroundColor: hoverBgColor }}>
                {columns.map((column, colIndex) => (
                  <Td
                    key={colIndex}
                    style={{ ...column.style, minWidth: column.style?.width }}
                    className={column.className || "table-row"}
                  >
                    {column.format ? column.format(row[column.accessor], row) : row[column.accessor]}
                  </Td>
                ))}
                {actions && (
                  <Td>
                    <Menu id={rowIndex+1}>
                      <MenuButton
                        as={IconButton}
                        icon={<FontAwesomeIcon icon={faEllipsisH} color={iconColor}/> }
                        bg={buttonBg}
                        _hover={{ backgroundColor: buttonHoverBg }}
                        size="sm"
                        borderRadius={8}
                      />
                      <MenuList>
                        {actions.map((action, actionIndex) => (
                          (!action.show || action.show(row)) && (
                            <MenuItem key={actionIndex} onClick={() => action.onClick(row)}>
                              {typeof action.label === 'function' ? action.label(row) : action.label}
                            </MenuItem>
                          )
                        ))}
                      </MenuList>
                    </Menu>
                  </Td>
                )}
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default CampaignTable;
